"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashPoleStatus = exports.DashPoleStatusConfig = exports.execHeaders = exports.statusHeaders = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const icons_1 = require("../../components/icon/icons");
const modal_style_1 = require("../../components/modal/modal.style");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const photomeasure_button_1 = require("../../modules/photomeasure.button/photomeasure.button");
const services_1 = require("../../services");
const page_1 = require("../page");
const dashboard_banner_1 = require("./dashboard.banner");
const dashboard_style_1 = require("./dashboard.style");
const dashboard_table_1 = require("./dashboard.table");
const dashboard_table_style_1 = require("./dashboard.table.style");
// original status headers
// export enum statusHeaders {
//     'BACKLOG',
//     'NOT COLLECTED',
//     'COLLECTED',
//     'HOA COMPLETE',
//     'PLA COMPLETE',
//     'MRA',
//     'RECOLLECT',
//     'BILLED',
//     'DONE'
// }
//analyst status headers
var statusHeaders;
(function (statusHeaders) {
    statusHeaders[statusHeaders["PLANNING"] = 0] = "PLANNING";
    statusHeaders[statusHeaders["COLLECT"] = 1] = "COLLECT";
    statusHeaders[statusHeaders["ASSIGN"] = 2] = "ASSIGN";
    statusHeaders[statusHeaders["LOCATION"] = 3] = "LOCATION";
    statusHeaders[statusHeaders["HOA"] = 4] = "HOA";
    statusHeaders[statusHeaders["MEAS QA"] = 5] = "MEAS QA";
    statusHeaders[statusHeaders["PLA"] = 6] = "PLA";
    statusHeaders[statusHeaders["MRE"] = 7] = "MRE";
    statusHeaders[statusHeaders["FINAL QA"] = 8] = "FINAL QA";
    statusHeaders[statusHeaders["DELIVERY"] = 9] = "DELIVERY";
    statusHeaders[statusHeaders["ACCEPTANCE"] = 10] = "ACCEPTANCE";
    statusHeaders[statusHeaders["BILLING"] = 11] = "BILLING";
    statusHeaders[statusHeaders["DONE"] = 12] = "DONE";
    statusHeaders[statusHeaders["REWORK"] = 13] = "REWORK";
})(statusHeaders || (exports.statusHeaders = statusHeaders = {}));
//exec status headers
var execHeaders;
(function (execHeaders) {
    execHeaders[execHeaders["PLANNING"] = 0] = "PLANNING";
    execHeaders[execHeaders["IKE FIELD"] = 1] = "IKE FIELD";
    execHeaders[execHeaders["IKE OFFICE"] = 2] = "IKE OFFICE";
    execHeaders[execHeaders["QA"] = 3] = "QA";
    execHeaders[execHeaders["DELIVERY"] = 4] = "DELIVERY";
    execHeaders[execHeaders["DONE"] = 5] = "DONE";
    execHeaders[execHeaders["REWORK"] = 6] = "REWORK";
})(execHeaders || (exports.execHeaders = execHeaders = {}));
//this need to be in the same order as the header enums
var headerMap = {
    PLANNING: 'PLANNING',
    COLLECT: 'IKE FIELD',
    ASSIGN: 'IKE OFFICE',
    LOCATION: 'IKE OFFICE',
    HOA: 'IKE OFFICE',
    'MEAS QA': 'IKE OFFICE',
    PLA: 'IKE OFFICE',
    MRE: 'IKE OFFICE',
    'FINAL QA': 'QA',
    DELIVERY: 'DELIVERY',
    ACCEPTANCE: 'DELIVERY',
    BILLING: 'DELIVERY',
    DONE: 'DONE',
    REWORK: 'REWORK'
};
exports.DashPoleStatusConfig = {
    type: 'internal',
    name: page_1.IkePageName.dashboardPolestatus,
    path: '/dashboard/pole_status',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.DASHBOARD_PAGE]
    },
    nav: {
        name: i18n_1.T.DASHBOARD,
        icon: icons_1.MaterialIcon.DASHBOARD
    },
    layout: { nav: false, banner: true }
};
class DashPoleStatus extends page_1.IkePage {
    constructor() {
        super(exports.DashPoleStatusConfig);
        this.poleStatusSum = null;
        this.execView = true; //starts off in executive view
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.poleStatusSum = yield services_1.Services.Dashboard.getPoleStatusSummary();
        });
    }
    get nodes() {
        let node = null;
        if (!(services_1.Services.Token.has(core_api_1.IkeToken.DASHBOARD_PAGE))) {
            node = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.message }, 'No Dashboard Token'));
            return node;
        }
        if (this.poleStatusSum == null) {
            this.init();
        }
        node = (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.container }, [
            dashboard_banner_1.DashBanner.nodes,
            this.viewTable()
        ]);
        return node;
    }
    toggleView() {
        this.execView = !this.execView;
    }
    getTableView() {
        return this.execView;
    }
    viewTable() {
        const rows = [];
        let poleStatTotal = [];
        let execPoleStatTotal = [];
        //zeroing out the totals aggregation arrays to be the length of the table headers
        //enums aren't easily iterable so they have to become objects first.
        for (let i = 0; i < (Object.keys(execHeaders).filter(k => typeof execHeaders[k] === 'number')).length; i++) {
            execPoleStatTotal[i] = 0;
        }
        for (let i = 0; i < (Object.keys(statusHeaders).filter(k => typeof statusHeaders[k] === 'number')).length; i++) {
            poleStatTotal[i] = 0;
        }
        //make sure we have data
        if (this.poleStatusSum != null) {
            let index = 0;
            this.poleStatusSum.forEach(el => {
                if (el != null) {
                    let jobName = el.jobName == null ? 'NULL' : el.jobName;
                    let jobId = el.jobId == null ? '' : el.jobId;
                    if (el.collectionStatusSummary != null) {
                        let poleStat = [];
                        let execPoleStat = [];
                        //zeroing out the row aggregation arrays to be the length of the table headers
                        for (let i = 0; i < (Object.keys(execHeaders).filter(k => typeof execHeaders[k] === 'number')).length; i++) {
                            execPoleStat[i] = 0;
                        }
                        for (let i = 0; i < (Object.keys(statusHeaders).filter(k => typeof statusHeaders[k] === 'number')).length; i++) {
                            poleStat[i] = 0;
                        }
                        el.collectionStatusSummary.forEach(col => {
                            if (col != null) {
                                if (col.collections != null && col.status != null) {
                                    // enum[enum_string] returns the place of that string in the enum
                                    // sorts the collection counts into the correct columns for exec and analyst views
                                    execPoleStat[execHeaders[headerMap[this.cleanStatus(col.status)]]] += col.collections;
                                    execPoleStatTotal[execHeaders[headerMap[this.cleanStatus(col.status)]]] += col.collections;
                                    poleStat[statusHeaders[this.cleanStatus(col.status)]] += col.collections;
                                    poleStatTotal[statusHeaders[this.cleanStatus(col.status)]] += col.collections;
                                }
                            }
                        });
                        //only show jobs that had at least some non null data
                        if (poleStat.reduce((a, b) => a + b, 0) > 0) {
                            index++;
                            rows.push(this.viewRow(index, jobId, jobName, this.execView ? execPoleStat : poleStat));
                        }
                    }
                }
            });
            //add the totals row to the top of the table
            rows.unshift(this.viewTotals(this.execView ? execPoleStatTotal : poleStatTotal));
            return dashboard_table_1.Table.view(this.viewTitle(), this.viewHeaders(), rows);
        }
        return (0, mithril_1.m)('div', {
            className: dashboard_style_1.CSS.message
        }, 'No Data Available');
    }
    viewTitle() {
        //the title also has a button to switch between views
        return (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.title }, [
            (0, mithril_1.m)('h6', {}, 'POLE STATUS'),
            (0, mithril_1.m)('button', {
                className: modal_style_1.MDL.button,
                onclick: (ev) => { this.toggleView(); }
            }, this.execView ? 'EXEC' : 'ANALYST')
        ]);
    }
    viewHeaders() {
        let headers = [];
        headers.push('#');
        headers.push('JOB NAME');
        if (this.execView) {
            const execH = Object.keys(execHeaders).filter(k => typeof execHeaders[k] === 'number');
            for (let i = 0; i < execH.length; i++) {
                headers.push(execH[i]);
            }
        }
        else {
            const statH = Object.keys(statusHeaders).filter(k => typeof statusHeaders[k] === 'number');
            for (let i = 0; i < statH.length; i++) {
                headers.push(statH[i]);
            }
        }
        headers.push('TOTAL');
        return headers;
    }
    viewTotals(totals) {
        let columns = [];
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, '-'));
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, 'TOTALS:'));
        for (let i = 0; i < totals.length; i++) {
            columns.push((0, mithril_1.m)('span', {
                className: ((this.execView ? 'execHeader' + i % 2 : 'execHeader' + (execHeaders[headerMap[statusHeaders[i]]] % 2)))
            }, totals[i] ? totals[i] : 0));
        }
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, totals.reduce((a, b) => a + b, 0)));
        return columns;
    }
    viewRow(index, id, name, cols) {
        let columns = [];
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, index));
        columns.push((0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellRoleActions }, [
            (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCell }, name),
            (0, mithril_1.m)('div', { className: dashboard_style_1.CSS.tableCellGhost }, photomeasure_button_1.PhotomeasureButton.view(id))
        ])); //jobname
        //iterates through the columns
        for (let i = 0; i < cols.length; i++) {
            columns.push((0, mithril_1.m)('span', {
                className: ((this.execView ? 'execHeader' + i % 2 : 'execHeader' + (execHeaders[headerMap[statusHeaders[i]]] % 2)))
            }, cols[i] ? cols[i] : 0));
        }
        //adds up everything for the total column
        columns.push((0, mithril_1.m)('span', { className: dashboard_style_1.CSS.tableCell }, cols.reduce((a, b) => a + b, 0)));
        return columns;
    }
    cleanStatus(status) {
        if (status != null) {
            const cleanStat = status.toUpperCase().trim();
            return cleanStat;
        }
        return '';
    }
}
exports.DashPoleStatus = DashPoleStatus;
tslib_1.__decorate([
    mobx_1.observable
], DashPoleStatus.prototype, "poleStatusSum", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DashPoleStatus.prototype, "execView", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DashPoleStatus.prototype, "viewTable", null);
tslib_1.__decorate([
    mobx_1.observable
], DashPoleStatus.prototype, "viewTitle", null);
tslib_1.__decorate([
    mobx_1.observable
], DashPoleStatus.prototype, "viewHeaders", null);
tslib_1.__decorate([
    mobx_1.observable
], DashPoleStatus.prototype, "viewRow", null);
//# sourceMappingURL=pole.status.page.js.map